import { useQuery } from "@apollo/client";
import { SENTINEL } from "../sentinels.queries";
import {
  SentinelQuery,
  SentinelQueryVariables,
} from "../../../__generated__/SentinelQuery";

export const useSentinel = (id: number) => {
  return useQuery<SentinelQuery, SentinelQueryVariables>(SENTINEL, {
    variables: { id },
  });
};
